export const projects = [
  {
    title: 'Wasiyah (منصة وصية)',
    subtitle: 'Digital Inheritance & GovTech Platform',
    date: 'Jan 2026',
    tech: ['ASP.NET Core', 'C#', 'SQL Server', 'Entity Framework', 'Bootstrap'],
    description: [
      'Built a secure digital will drafting system with automated execution protocols',
      'Simulated government integration with Civil Affairs for death status triggers',
      'Implemented Role-Based Access Control and Many-to-Many database architecture'
    ],
    liveUrl: 'https://github.com/AlnemerAbdulwahab/WasiyahApp-Showcase'
  },
  {
    title: 'SubsTrack',
    subtitle: 'Subscription Management App',
    date: 'Aug 2023 - May 2024',
    tech: ['React Native', 'JavaScript', 'TypeScript', 'Figma'],
    description: [
      'Developed centralized dashboard for subscription management',
      'Implemented intelligent renewal reminder system',
      'Built cost tracking and budgeting tools'
    ],
    liveUrl: 'https://github.com/AlnemerAbdulwahab/Substrack-App-Showcase'
  },
  {
    title: 'Qudratak - Qiyas Qudrat Exam Practice App',
    subtitle: 'Educational Mobile App',
    date: 'Aug 2024 - Sep 2024',
    tech: ['React Native', 'JavaScript', 'TypeScript', 'Figma'],
    description: [
      'Created exam practice app with randomized questions',
      'Built performance tracking system',
      'Delivered cross-platform prototype in one week'
    ],
    liveUrl: 'https://github.com/AlnemerAbdulwahab/Qudratak-App-Showcase/'
  }
];
